/* eslint-disable */
/**
 * * This file was automatically generated by react-scripts-trackman codegen.
 * * DO NOT MODIFY IT BY HAND. Instead, modify endpoint definitions in backend,
 * * start backend to regenerate swagger.json, and run react-scripts-trackman codegen
 * * to regenerate this file.
 * *
 * * If you find errors in this file, do the following (in order):
 * * 1. Check Swagger configuration in backend (often SwaggerResponse is wrongly defined)
 * * 2. Check backend type and controller definitions
 * * 3. Check if the endpoint is properly defined in consumedEndpoints.json
 * * 4. Report the issue to react-scripts-trackman maintainers (mga@trackman.com)
 */

import {
  BatterReportFilterDto,
  BatterPlayerReportResultDto,
  UmpireReportFilterDto,
  UmpireReportResultDto,
  UmpireReportForSessionFilterDto,
  UmpireReportForSessionResultDto,
  UmpireReportForAdminFilterDto,
  UmpireReportForAdminResultDto,
  PlayerReportContentConfigDto,
  PitcherPlayerReportResultDto,
  UpdatePitcherReportSetupDto,
  PitcherReportFilterDto,
  PitcherLayoutResultDto,
  UpdatePitcherReportLayoutDto,
  PitcherSessionReportFilterDto,
  PitcherSessionReportResultDto,
  BatterSessionReportFilterDto,
  BatterSessionReportResultDto,
  UpdateBatterReportSetupDto,
  BatterLayoutResultDto,
  UpdateBatterReportLayoutDto,
  UpdatePitcherSessionReportSetupDto,
  PitcherSessionReportLayoutResultDto,
  UpdatePitcherSessionReportLayoutDto,
  UpdateBatterSessionReportSetupDto,
  BatterSessionReportLayoutResultDto,
  UpdateBatterSessionReportLayoutDto,
  UmpireReportContentConfigDto,
  UpdateAllSessionsUmpireReportSetupDto,
  UmpireLayoutResultDto,
  UpdateUmpireReportLayoutDto,
  UpdateSingleSessionUmpireReportSetupDto,
  UmpireLayoutForSessionResultDto,
  UpdateUmpireReportForSessionLayoutDto,
  UmpireReportForAdminContentConfigDto,
  UpdateAdminOverviewUmpireReportSetupDto,
  UmpireLayoutForAdminResultDto,
  UpdateUmpireReportForAdminLayoutDto,
  BatterSingleSessionReportResultDto,
  UpdateBatterSingleSessionReportSetupDto,
  BatterSingleSessionReportFilterDto,
  BatterSingleSessionReportLayoutResultDto,
  UpdateBatterSingleSessionReportLayoutDto,
  PitcherSingleSessionReportResultDto,
  UpdatePitcherSingleSessionReportSetupDto,
  PitcherSingleSessionReportFilterDto,
  PitcherSingleSessionReportLayoutResultDto,
  UpdatePitcherSingleSessionReportLayoutDto,
} from '../types/CodegenReportTypes';
import { AxiosInstance } from 'axios';
import { Result } from '../types/CodegenResult';

export class ReportService {
  private axiosInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  postReportPlayerReportBatterGenerate = async (requestBody: BatterReportFilterDto) => {
    const response = await this.axiosInstance.post<Result<BatterPlayerReportResultDto>>(
      `/api/v1/Report/playerReport/batter/generate`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportUmpireReportAllSessionsGenerate = async (requestBody: UmpireReportFilterDto) => {
    const response = await this.axiosInstance.post<Result<UmpireReportResultDto>>(
      `/api/v1/Report/umpireReport/allSessions/generate`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportUmpireReportSingleSessionGenerate = async (requestBody: UmpireReportForSessionFilterDto) => {
    const response = await this.axiosInstance.post<Result<UmpireReportForSessionResultDto>>(
      `/api/v1/Report/umpireReport/singleSession/generate`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportUmpireReportAdminOverviewGenerate = async (requestBody: UmpireReportForAdminFilterDto) => {
    const response = await this.axiosInstance.post<Result<UmpireReportForAdminResultDto>>(
      `/api/v1/Report/umpireReport/adminOverview/generate`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPlayerReportPitcherGetReportData = async (requestBody: PlayerReportContentConfigDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<PitcherPlayerReportResultDto>>(
      `/api/v1/Report/playerReport/pitcher/get-report-data`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPlayerReportPitcherUpdateReportSetup = async (requestBody: UpdatePitcherReportSetupDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<PitcherPlayerReportResultDto>>(
      `/api/v1/Report/playerReport/pitcher/update-report-setup`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPlayerReportPitcherGenerate = async (requestBody: PitcherReportFilterDto) => {
    const response = await this.axiosInstance.post<Result<PitcherPlayerReportResultDto>>(
      `/api/v1/Report/playerReport/pitcher/generate`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  getReportPlayerReportPitcherOrgLayout = async () => {
    const response = await this.axiosInstance.get<Result<PitcherLayoutResultDto>>(`/api/v1/Report/playerReport/pitcher/org-layout`);
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPlayerReportPitcherOrgLayout = async (requestBody: UpdatePitcherReportLayoutDto) => {
    const response = await this.axiosInstance.post<Result<UpdatePitcherReportLayoutDto>>(
      `/api/v1/Report/playerReport/pitcher/org-layout`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportPitcherAggregatedGenerate = async (requestBody: PitcherSessionReportFilterDto) => {
    const response = await this.axiosInstance.post<Result<PitcherSessionReportResultDto>>(
      `/api/v1/Report/sessionReviewReport/pitcherAggregated/generate`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportBatterAggregatedGenerate = async (requestBody: BatterSessionReportFilterDto) => {
    const response = await this.axiosInstance.post<Result<BatterSessionReportResultDto>>(
      `/api/v1/Report/sessionReviewReport/batterAggregated/generate`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPlayerReportBatterGetReportData = async (requestBody: PlayerReportContentConfigDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<BatterPlayerReportResultDto>>(
      `/api/v1/Report/playerReport/batter/get-report-data`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPlayerReportBatterUpdateReportSetup = async (requestBody: UpdateBatterReportSetupDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<BatterPlayerReportResultDto>>(
      `/api/v1/Report/playerReport/batter/update-report-setup`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  getReportPlayerReportBatterOrgLayout = async () => {
    const response = await this.axiosInstance.get<Result<BatterLayoutResultDto>>(`/api/v1/Report/playerReport/batter/org-layout`);
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportPlayerReportBatterOrgLayout = async (requestBody: UpdateBatterReportLayoutDto) => {
    const response = await this.axiosInstance.post<Result<UpdateBatterReportLayoutDto>>(
      `/api/v1/Report/playerReport/batter/org-layout`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportPitcherAggregatedGetReportData = async (requestBody: PlayerReportContentConfigDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<PitcherSessionReportResultDto>>(
      `/api/v1/Report/sessionReviewReport/pitcherAggregated/get-report-data`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportPitcherAggregatedUpdateReportSetup = async (
    requestBody: UpdatePitcherSessionReportSetupDto,
    reportId?: string
  ) => {
    const response = await this.axiosInstance.post<Result<PitcherSessionReportResultDto>>(
      `/api/v1/Report/sessionReviewReport/pitcherAggregated/update-report-setup`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  getReportSessionReviewReportPitcherAggregatedOrgLayout = async () => {
    const response = await this.axiosInstance.get<Result<PitcherSessionReportLayoutResultDto>>(
      `/api/v1/Report/sessionReviewReport/pitcherAggregated/org-layout`
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportPitcherAggregatedOrgLayout = async (requestBody: UpdatePitcherSessionReportLayoutDto) => {
    const response = await this.axiosInstance.post<Result<UpdatePitcherSessionReportLayoutDto>>(
      `/api/v1/Report/sessionReviewReport/pitcherAggregated/org-layout`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportBatterAggregatedGetReportData = async (requestBody: PlayerReportContentConfigDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<BatterSessionReportResultDto>>(
      `/api/v1/Report/sessionReviewReport/batterAggregated/get-report-data`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportBatterAggregatedUpdateReportSetup = async (
    requestBody: UpdateBatterSessionReportSetupDto,
    reportId?: string
  ) => {
    const response = await this.axiosInstance.post<Result<BatterSessionReportResultDto>>(
      `/api/v1/Report/sessionReviewReport/batterAggregated/update-report-setup`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  getReportSessionReviewReportBatterAggregatedOrgLayout = async () => {
    const response = await this.axiosInstance.get<Result<BatterSessionReportLayoutResultDto>>(
      `/api/v1/Report/sessionReviewReport/batterAggregated/org-layout`
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportBatterAggregatedOrgLayout = async (requestBody: UpdateBatterSessionReportLayoutDto) => {
    const response = await this.axiosInstance.post<Result<UpdateBatterSessionReportLayoutDto>>(
      `/api/v1/Report/sessionReviewReport/batterAggregated/org-layout`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportUmpireReportAllSessionsGetReportData = async (requestBody: UmpireReportContentConfigDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<UmpireReportResultDto>>(
      `/api/v1/Report/umpireReport/allSessions/get-report-data`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportUmpireReportAllSessionsUpdateReportSetup = async (requestBody: UpdateAllSessionsUmpireReportSetupDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<UmpireReportResultDto>>(
      `/api/v1/Report/umpireReport/allSessions/update-report-setup`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  getReportUmpireReportAllSessionsOrgLayout = async () => {
    const response = await this.axiosInstance.get<Result<UmpireLayoutResultDto>>(`/api/v1/Report/umpireReport/allSessions/org-layout`);
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportUmpireReportAllSessionsOrgLayout = async (requestBody: UpdateUmpireReportLayoutDto) => {
    const response = await this.axiosInstance.post<Result<UpdateUmpireReportLayoutDto>>(
      `/api/v1/Report/umpireReport/allSessions/org-layout`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportUmpireReportSingleSessionGetReportData = async (requestBody: UmpireReportContentConfigDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<UmpireReportForSessionResultDto>>(
      `/api/v1/Report/umpireReport/singleSession/get-report-data`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportUmpireReportSingleSessionUpdateReportSetup = async (
    requestBody: UpdateSingleSessionUmpireReportSetupDto,
    reportId?: string
  ) => {
    const response = await this.axiosInstance.post<Result<UmpireReportForSessionResultDto>>(
      `/api/v1/Report/umpireReport/singleSession/update-report-setup`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  getReportUmpireReportSingleSessionOrgLayout = async () => {
    const response = await this.axiosInstance.get<Result<UmpireLayoutForSessionResultDto>>(
      `/api/v1/Report/umpireReport/singleSession/org-layout`
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportUmpireReportSingleSessionOrgLayout = async (requestBody: UpdateUmpireReportForSessionLayoutDto) => {
    const response = await this.axiosInstance.post<Result<UpdateUmpireReportForSessionLayoutDto>>(
      `/api/v1/Report/umpireReport/singleSession/org-layout`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportUmpireReportAdminOverviewGetReportData = async (requestBody: UmpireReportForAdminContentConfigDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<UmpireReportForAdminResultDto>>(
      `/api/v1/Report/umpireReport/adminOverview/get-report-data`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportUmpireReportAdminOverviewUpdateReportSetup = async (
    requestBody: UpdateAdminOverviewUmpireReportSetupDto,
    reportId?: string
  ) => {
    const response = await this.axiosInstance.post<Result<UmpireReportForAdminResultDto>>(
      `/api/v1/Report/umpireReport/adminOverview/update-report-setup`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  getReportUmpireReportAdminOverviewOrgLayout = async () => {
    const response = await this.axiosInstance.get<Result<UmpireLayoutForAdminResultDto>>(
      `/api/v1/Report/umpireReport/adminOverview/org-layout`
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportUmpireReportAdminOverviewOrgLayout = async (requestBody: UpdateUmpireReportForAdminLayoutDto) => {
    const response = await this.axiosInstance.post<Result<UpdateUmpireReportForAdminLayoutDto>>(
      `/api/v1/Report/umpireReport/adminOverview/org-layout`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportBatterSingleSessionGetReportData = async (requestBody: PlayerReportContentConfigDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<BatterSingleSessionReportResultDto>>(
      `/api/v1/Report/sessionReviewReport/batterSingleSession/get-report-data`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportBatterSingleSessionUpdateReportSetup = async (
    requestBody: UpdateBatterSingleSessionReportSetupDto,
    reportId?: string
  ) => {
    const response = await this.axiosInstance.post<Result<BatterSingleSessionReportResultDto>>(
      `/api/v1/Report/sessionReviewReport/batterSingleSession/update-report-setup`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportBatterSingleSessionGenerate = async (requestBody: BatterSingleSessionReportFilterDto) => {
    const response = await this.axiosInstance.post<Result<BatterSingleSessionReportResultDto>>(
      `/api/v1/Report/sessionReviewReport/batterSingleSession/generate`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  getReportSessionReviewReportBatterSingleSessionOrgLayout = async () => {
    const response = await this.axiosInstance.get<Result<BatterSingleSessionReportLayoutResultDto>>(
      `/api/v1/Report/sessionReviewReport/batterSingleSession/org-layout`
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportBatterSingleSessionOrgLayout = async (requestBody: UpdateBatterSingleSessionReportLayoutDto) => {
    const response = await this.axiosInstance.post<Result<UpdateBatterSingleSessionReportLayoutDto>>(
      `/api/v1/Report/sessionReviewReport/batterSingleSession/org-layout`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportPitcherSingleSessionGetReportData = async (requestBody: PlayerReportContentConfigDto, reportId?: string) => {
    const response = await this.axiosInstance.post<Result<PitcherSingleSessionReportResultDto>>(
      `/api/v1/Report/sessionReviewReport/pitcherSingleSession/get-report-data`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportPitcherSingleSessionUpdateReportSetup = async (
    requestBody: UpdatePitcherSingleSessionReportSetupDto,
    reportId?: string
  ) => {
    const response = await this.axiosInstance.post<Result<PitcherSingleSessionReportResultDto>>(
      `/api/v1/Report/sessionReviewReport/pitcherSingleSession/update-report-setup`,
      requestBody,
      { params: { reportId }, paramsSerializer: { indexes: null } }
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportPitcherSingleSessionGenerate = async (requestBody: PitcherSingleSessionReportFilterDto) => {
    const response = await this.axiosInstance.post<Result<PitcherSingleSessionReportResultDto>>(
      `/api/v1/Report/sessionReviewReport/pitcherSingleSession/generate`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  getReportSessionReviewReportPitcherSingleSessionOrgLayout = async () => {
    const response = await this.axiosInstance.get<Result<PitcherSingleSessionReportLayoutResultDto>>(
      `/api/v1/Report/sessionReviewReport/pitcherSingleSession/org-layout`
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };

  postReportSessionReviewReportPitcherSingleSessionOrgLayout = async (requestBody: UpdatePitcherSingleSessionReportLayoutDto) => {
    const response = await this.axiosInstance.post<Result<UpdatePitcherSingleSessionReportLayoutDto>>(
      `/api/v1/Report/sessionReviewReport/pitcherSingleSession/org-layout`,
      requestBody
    );
    if (!response) throw Error('No response');
    if (response.status === 200 && response.data && response.data.data !== undefined) return response.data.data;
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };
}

export default ReportService;
